<footer class="container-footer">
  <div class="container-footer-info">
    <span class="container-footer-info-text" [class._white]="isWhiteLogo">Powered by</span>
    <img class="container-footer-info-logo" [src]="logoUrl" alt="">
  </div>
</footer>
